<script lang="ts">
  /**
   * Curation-duel status pill: open (claim window) / voting / ended.
   * Unknown strings (legacy rows, future statuses) fall back to a muted gray
   * pill echoing the raw status so nothing renders blank or crashes.
   */
  let { status }: { status: string } = $props();

  const known = $derived(status === 'open' || status === 'voting' || status === 'ended');
  const label = $derived(
    status === 'open' ? 'Open' : status === 'voting' ? 'Voting' : status === 'ended' ? 'Ended' : status,
  );
</script>

<span
  class="duel-status"
  class:duel-status--open={status === 'open'}
  class:duel-status--voting={status === 'voting'}
  class:duel-status--ended={status === 'ended'}
  class:duel-status--unknown={!known}>{label}</span
>

<style>
  .duel-status {
    display: inline-block;
    font-size: 0.7rem;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: 3px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    white-space: nowrap;
  }
  .duel-status--open {
    background: var(--cyan);
    color: #000;
  }
  .duel-status--voting {
    background: var(--pink);
    color: #fff;
    animation: duel-status-pulse 2s ease-in-out infinite;
  }
  .duel-status--ended {
    background: var(--border);
    color: var(--text-muted);
  }
  .duel-status--unknown {
    background: var(--surface-2);
    color: var(--text-muted);
  }
  @keyframes duel-status-pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.65;
    }
  }
</style>
